module.exports = __webpack_public_path__ + "img/img41.d3e9890a.svg";